/**
 * 这里加载第三库文件（文件都放在libs目录里）
 */

import 'script-loader!./libs/test.js';
// import 'script-loader!./libs/clipboard.min.js';
